import React from 'react'
import useStore from 'state/knovStore'
import styles from 'components/answers/answer-controls.module.scss'
import cn from 'classnames'
import WithTooltip from 'components/shared/WithTooltip'
import { isMobile } from 'lib/device'

export default function RecordScreenButton(props) {
    const openScreenRecorderModal = useStore(
        state => state.actions.modalActions.openScreenRecorderModal,
    )
    const openAuthModal = useStore(state => state.actions.modalActions.openAuthModal)

    const onVideo = () => {
        if (!gon.currentUser) {
            openAuthModal('signup', 'record_screen')
            return
        }

        window.logEv('CLICK_RECORD_SCREEN_BUTTON', {
            answer_id: props.answer?.id,
            quest_id: props.quest?.id || props.answer?.quest_id,
            from_location: 'answer_controls',
        })
        openScreenRecorderModal(props.quest, props.videoHandler, props.answer)
    }

    const answerHoverStyles = props.answerHover ? styles.hoverBtn : null
    const mobileStyles = isMobile ? styles.mobileBtn : null

    return (
        <WithTooltip tip="Record screen.">
            <div
                className={cn(
                    styles.editMediaBtn,
                    answerHoverStyles,
                    styles.videoHover,
                    styles.recordScreenBtn,
                    'quest-btn video-modal-btn',
                    mobileStyles,
                )}
                onClick={onVideo}
            >
                <i className="fa fa-desktop"></i>
            </div>
        </WithTooltip>
    )
}
